var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-container" },
    [
      _vm.count >= 1
        ? _c("div", { staticClass: "cart" }, [
            _c("p", { staticClass: "cart__heading" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("formatString")(
                      _vm.count == 1
                        ? _vm.$modeoL10n.one_product_in_total
                        : _vm.$modeoL10n.x_products_in_total,
                      _vm.count
                    )
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cart__items-heading" }, [
              _c(
                "span",
                {
                  staticClass:
                    "cart__column cart__column--heading cart__column--heading--product cart__column--product"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$modeoL10n.product) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "cart__column cart__column--heading cart__column--availability"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$modeoL10n.availability) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "cart__column cart__column--heading cart__column--price"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$modeoL10n.price) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "cart__column cart__column--heading cart__column--amount"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$modeoL10n.amount) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "cart__column cart__column--heading cart__column--sum"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$modeoL10n.total) + "\n      "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cart__items", attrs: { role: "list" } },
              [
                _vm._l(_vm.cartContents, function(cartItem) {
                  return [
                    _c("CartItem", {
                      key: cartItem.key,
                      attrs: {
                        "original-cart-item": cartItem,
                        "order-type": "order"
                      },
                      on: {
                        remove: function($event) {
                          return _vm.removeItem(cartItem)
                        },
                        update: function($event) {
                          return _vm.updateCartItem(cartItem, $event)
                        }
                      }
                    })
                  ]
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.count == 0
        ? _c("div", { staticClass: "cart__empty-container empty-cart" }, [
            _c("p", { staticClass: "empty-cart__text" }, [
              _vm._v("\n      " + _vm._s(_vm.$modeoL10n.no_products) + "\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "cart-footer" }, [
        _c(
          "a",
          {
            staticClass: "cart-footer__button btn btn--small btn--secondary",
            attrs: {
              target: "_blank",
              href: _vm.$store.getters.showPricesWithVat
                ? "?format=pdf&show_prices=true&vat=true"
                : "?format=pdf&show_prices=true&vat=false"
            }
          },
          [_vm._v(_vm._s(_vm.$modeoL10n.download_details_as_pdf))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "cart-footer__button btn btn--small btn--secondary",
            attrs: { target: "_blank", href: "?format=pdf" }
          },
          [
            _vm._v(
              _vm._s(_vm.$modeoL10n.download_details_as_pdf_without_prices)
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("CheckoutCoupons", { attrs: { nonce: _vm.nonce } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6204ae32", { render: render, staticRenderFns: staticRenderFns })
  }
}